import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TableBody, TableHead, TableRow, Checkbox } from '@mui/material';
import CloudDownloadOutlined from '@mui/icons-material/CloudDownloadOutlined';
import { DenseHeaderTableCell, TableStyled } from './DocumentsStyles';
import { IconButton } from '@totalsoft/rocket-ui';

const DocumentsUploadHistoryComponent = ({ documentHistory, downloadFile }) => {
  const { t } = useTranslation();

  return (
    <>
      <div style={{ width: '100%' }}>
        <TableStyled>
          <TableHead>
            <TableRow>
              <DenseHeaderTableCell width='40%'>{t('OfferEdit.Documents.History.OriginalFileName')}</DenseHeaderTableCell>
              <DenseHeaderTableCell width='20%'>{t('OfferEdit.Documents.History.UploadDate')}</DenseHeaderTableCell>
              <DenseHeaderTableCell width='20%'>{t('OfferEdit.Documents.History.UploadedBy')}</DenseHeaderTableCell>
              <DenseHeaderTableCell width='10%'>{t('OfferEdit.Documents.History.IsDeleted')}</DenseHeaderTableCell>
              <DenseHeaderTableCell width='10%'>{t('OfferEdit.Documents.History.Action')}</DenseHeaderTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {documentHistory?.map(n => {
              return (
                <TableRow key={n.fileId}>
                  <DenseHeaderTableCell>{n.originalFileName}</DenseHeaderTableCell>
                  <DenseHeaderTableCell>
                    {t('DATE_FORMAT', { date: { value: n.exportedDate, format: 'DD.MM.YYYY HH:mm:ss' } })}
                  </DenseHeaderTableCell>
                  <DenseHeaderTableCell>{n.exportedBy}</DenseHeaderTableCell>
                  <DenseHeaderTableCell>
                    <Checkbox checked={n.isDeleted} disabled={true} />
                  </DenseHeaderTableCell>
                  <DenseHeaderTableCell>
                    <IconButton
                      variant='text'
                      disabled={n.isDeleted}
                      onClick={downloadFile(n.fileId)}
                      tooltip={n.isDeleted ? t('Tooltips.Deleted') : t('Tooltips.Download')}
                    >
                      <CloudDownloadOutlined color={n.isDeleted ? 'error' : 'default'} />
                    </IconButton>
                  </DenseHeaderTableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </TableStyled>
      </div>
    </>
  );
};

DocumentsUploadHistoryComponent.propTypes = {
  documentHistory: PropTypes.array,
  downloadFile: PropTypes.func.isRequired
};

export default DocumentsUploadHistoryComponent;
